export default __webpack_public_path__ + "static/media/videoType.900ae862.svg";